import React, { useMemo } from 'react';
import DiscourseControls from '../DiscourseControls/DiscourseControls';
import DiscourseForm from '../DiscrouseForm/DiscourseForm';
// @ts-ignore
import styles from './Discourse.module.scss';
import { useAclContext } from '../../../Acl/Components/AclContextProvider';
import Text from '../../../../Components/Base/Text/Text';
import DiscourseHistory from '../DiscourseHistory/DiscourseHistory';
import { DiscourseContextProvider } from '../../Services/DiscourseContext';
import { useAppContext } from '../../../../Services/AppContext';
import { useGetUserOriginalIdQuery } from '../../../../graphql/graphql';
import Loading from '../../../../Components/Loading';

interface Props {
	patientId: string;
	workplaceId: string;
	caseId?: string;
}

const Discourse: React.FC<Props> = ({ patientId, workplaceId, caseId }) => {
	const { isAllowed } = useAclContext();
	const { userData } = useAppContext();
	const user = useGetUserOriginalIdQuery({ id: patientId });

	const originalId = useMemo(() => {
		return user?.data?.user?.originalId ?? undefined;
	}, [user]);

	if (!originalId) {
		return <Loading />;
	}

	return (
		<DiscourseContextProvider
			patientId={originalId}
			workplaceId={workplaceId}
			loggedUserId={userData.id}>
			<div className={styles.wrapper}>
				<DiscourseControls
					allowElectronicPrescription={isAllowed('erecept_erecept')}
					allowMedicalReport={isAllowed('medical_report')}
					workplaceId={workplaceId}
					caseId={caseId}
					patientId={originalId}
					virtualPatientId={patientId}
				/>
				<DiscourseForm patientId={originalId} />
				<div className={styles.historyWrapper}>
					<Text
						tx={'discourse.discourseHistory'}
						className={styles.title}
						firstUpper={true}
					/>
					<DiscourseHistory patientId={originalId} workplaceId={workplaceId} />
				</div>
			</div>
		</DiscourseContextProvider>
	);
};

export default Discourse;
